<div [ngStyle]="contentStyle" class="section password-forgot pointer-events-none">
  <p *ngIf="dataIn?.attri?.widgetProperties?.subHeadingLabel" [ngStyle]="mergedHeadingStyle">
    {{ dataIn?.attri?.widgetProperties?.subHeadingLabel }}
  </p>

  <div class="text-left">
    <form class="beneficiary-form" [formGroup]="passwordForm">
      <div class="finxForm" [ngStyle]="parentFormWidgetRowGap ? { gap: parentFormWidgetRowGap } : {}">
        <div class="field-wrapper position-relative">
          <finxone-input
            [type]="fieldTypes['newPassword']"
            [name]="'newPassword'"
            [label]="dataIn?.attri?.widgetProperties['passFieldLabel1']"
            formControlName="newPassword"
            [formControlInvalid]="
              !!(
                passwordForm.controls['newPassword']?.dirty &&
                passwordForm.controls['newPassword']?.invalid &&
                passwordForm.controls['newPassword']?.touched
              )
            "
            [value]="passwordForm.controls['newPassword']?.value ?? ''"
            [validationConfig]="[
              {
                type: 'required',
                message: 'Password fields cannot be empty'
              }
            ]"
            [validationConfig]="[
                  {
                    type: 'required',
                    message: getRequiredMessage(dataIn?.attri?.widgetProperties['passFieldLabel1'], 'passwordRequired')
                  },
                  {
                    type: 'passwordRules',
                    message:
                      customValidationMessages?.['passwordValidation'] ||
                      validationMessages.invalidInput(dataIn?.attri?.widgetProperties['passFieldLabel1']),
                    validatorFn: passwordRulesValidatorFn
                  }
                ]"
          >
            <div
              suffix
              *ngTemplateOutlet="inputFieldIcons; context: {
              formControlName: 'newPassword',
              iconsConfig: passwordFieldConfigs?.cssConfig,
              fieldTypes: fieldTypes,
            }"
            ></div>
          </finxone-input>
        </div>
        <div class="position-relative">
          <finxone-input
            [type]="fieldTypes['confirmPassword']"
            [name]="'confirmPassword'"
            [label]="dataIn?.attri?.widgetProperties['passFieldLabel2']"
            formControlName="confirmPassword"
            [formControlInvalid]="
              !!(
                passwordForm.controls['confirmPassword']?.dirty &&
                passwordForm.controls['confirmPassword']?.invalid &&
                passwordForm.controls['confirmPassword']?.touched
              )
            "
            [value]="passwordForm.controls['confirmPassword']?.value ?? ''"
            [validationConfig]="[
                  {
                    type: 'required',
                    message: getRequiredMessage(dataIn?.attri?.widgetProperties['passFieldLabel2'], 'confirmPasswordRequired')
                  },
                  {
                    type: 'passwordRules',
                    message:
                      customValidationMessages?.['passwordValidation'] ||
                      validationMessages.invalidInput(dataIn?.attri?.widgetProperties['passFieldLabel2']),
                    validatorFn: passwordRulesValidatorFn
                  }
                ]"
          >
            <div
              suffix
              *ngTemplateOutlet="inputFieldIcons; context: {
              formControlName: 'confirmPassword',
              iconsConfig: passwordFieldConfigs?.cssConfig,
              fieldTypes: fieldTypes,
            }"
            ></div>
          </finxone-input>
          <div class="text-error typog-xs" *ngIf="isError && errorMsg">
            <span>{{ errorMsg }}</span>
          </div>
        </div>
        <finxone-web-frontend-password-rules
          [passwordForm]="passwordForm"
          [passwordMatchTemplate]="dataIn.attri['widgetProperties']?.['passwordMatchTemplate']"
          [passwordNoMatchTemplate]="dataIn.attri['widgetProperties']?.['passwordNoMatchTemplate']"
          (allPasswordRulesPassed)="allPasswordRulesPassed($event)"
        ></finxone-web-frontend-password-rules>
        <div>
          <finx-button
            [class]="isAllowedGlobalStyling ? globalStylingClass : 'w-100'"
            (click)="enableSubmit = true; onSubmit()"
            [buttonStyle]="!isAllowedGlobalStyling ? reviewDetailsButtonStyle : {}"
            [class.mandatory-cta-button]="!isAllowedGlobalStyling"
            [isAllowedGlobalStyling]="isAllowedGlobalStyling"
            type="button"
            [labeltext]="renderedContent"
            [disabled]="!formIsValid"
          ></finx-button>
        </div>
      </div>
    </form>
  </div>
</div>

<ng-template
  #inputFieldIcons
  let-formControlName="formControlName"
  let-iconsConfig="iconsConfig"
  let-fieldTypes="fieldTypes"
>
  <div class="password-field-icons gap-1">
    <span
      class="password-field-eye-icon"
      (click)="togglePasswordFieldType(formControlName, 'text')"
      *ngIf="fieldTypes[formControlName] === 'password' && (iconsConfig?.showPasswordIconVisible ?? true)"
    >
      <mat-icon [svgIcon]="iconsConfig?.showPasswordIcon ?? 'pass-eye'"></mat-icon>
    </span>
    <span
      class="password-field-eye-icon"
      (click)="togglePasswordFieldType(formControlName, 'password')"
      *ngIf="fieldTypes[formControlName] === 'text' && (iconsConfig?.showPasswordIconVisible ?? true)"
    >
      <mat-icon [svgIcon]="iconsConfig?.hidePasswordIcon ?? 'pass-eye-hide'"></mat-icon>
    </span>
  </div>
</ng-template>
